module.exports = __webpack_public_path__ + "static/media/md-volume-off.3f8924a4.svg";